import { UserFileSizeLimitFail } from './UserFileSizeLimitFail';

export class GlobalFileSizeLimitFail extends UserFileSizeLimitFail {
    limit = 0;
    radarName = 'fail_{SOURCE}_global-file-size-limit';
    message = 'В Облако нельзя загружать файлы более {LIMIT}.';
}
